import cardSlider from './card-slider.js';

document.addEventListener('DOMContentLoaded', ()=>{
    if (!window.cardSlider) {
        window.cardSlider = {};
    }
    cardSlider();
});